import { ClientCreation } from '@Arti-zen/package-backoffice'
import { cleanString, containsInvalidSymbol } from 'utils/schema.helper'
import { boolean, mixed, object, string } from 'yup'
import { ETitleClient } from './TitleErrorTable'

const clientSchema = object({
  lastName: string()
    .trim()
    .transform((value) => cleanString(value))
    .required('Le nom est obligatoire')
    .test('invalid-symbol', 'Contient au moins un caractère invalide.', (value) => !containsInvalidSymbol(value)),
  firstName: string()
    .nullable()
    .test('invalid-symbol', 'Contient au moins un caractère invalide.', (value) => !containsInvalidSymbol(value)),
  address: string()
    .nullable()
    .test('invalid-symbol', 'Contient au moins un caractère invalide.', (value) => !containsInvalidSymbol(value)),
  additionalAddress: string()
    .nullable()
    .test('invalid-symbol', 'Contient au moins un caractère invalide.', (value) => !containsInvalidSymbol(value)),
  isProfessional: boolean().nonNullable().required('Le type de client est obligatoire'),
  phone: string()
    .nullable()
    .test('phone', 'Le numéro de téléphone est incorrect', (value) => {
      if (!value) return true

      const cleanedPhone = value.replace(/\s/g, '')

      return (
        /^\+?\d+$/.test(cleanedPhone) &&
        (cleanedPhone.startsWith('+') ? cleanedPhone.length === 12 : cleanedPhone.length === 10)
      )
    }),
  mobile: string()
    .nullable()
    .test('mobile', 'Le numéro de téléphone est incorrect', (value) => {
      if (!value) return true

      const cleanedPhone = value.replace(/\s/g, '')

      return (
        /^\+?\d+$/.test(cleanedPhone) &&
        (cleanedPhone.startsWith('+') ? cleanedPhone.length === 12 : cleanedPhone.length === 10)
      )
    }),
  email: string()
    .nullable()
    .test('email', "L'email est incorrect", (value) => {
      if (!value) return true
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
    }),
  city: string().nullable(),
  postalCode: string().nullable(),
  title: string()
    .nullable()
    .test('title', 'La civilité est incorrecte', function (value) {
      if (!value) return true
      const { isProfessional } = this.parent as ClientCreation
      if (isProfessional === true) {
        return this.createError({
          message: 'Un client professionnel ne peut pas avoir de civilité',
        })
      }
      return Object.values(ETitleClient).includes(value as ETitleClient)
    }),
  siren: string()
    .nullable()
    .test('siren-professional', 'Le SIRET est incorrect', function (value) {
      const { isProfessional } = this.parent as ClientCreation

      if (isProfessional === true && !value) {
        return this.createError({
          message: 'Le SIRET est obligatoire pour un client professionnel',
        })
      }

      if (isProfessional === false && value) {
        return this.createError({
          message: 'Un client particulier ne peut pas avoir de SIRET',
        })
      }

      if (!value) return true

      return /^\d{14}$/.test(value.trim())
    }),
})

export default clientSchema
